export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    /**
     * @description 请求项目中的文件
     * @param {String} url 文件地址
     */
    FILE_GET: function FILE_GET() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return request({
        baseURL: process.env.BASE_URL,
        url: url,
        method: 'get'
      });
    }
  };
});